import React from "react";
import buildColor from "@fdr/static-ui/ColorPalette";
import Text from "@fdr/atomic-ui/_atoms/Text";
import RunnerNumber from "@fdr/atomic-ui/_atoms/RunnerNumber";
import { RaceTypeCodeEnum, RaceOdds } from "@tvg/ts-types/Race";
import { RunnerChance } from "./types";
import {
  Container,
  LeftSide,
  RunnerNumberWrapper,
  HighlightedTextWrapper,
  DerbyChanceHighlighted,
  TextDerbyPickOdds
} from "./styled-components";

export interface Props {
  // Label representing chance of the racer
  runnerChance: RunnerChance;
  // Runner number
  runnerId: number;
  // Runner name
  runnerName: string;
  // Win amount for this bet
  winAmount?: number;
  // Race Code
  raceTypeCode: RaceTypeCodeEnum;
  // qaLabel
  qaLabel?: string;
  // odds
  odds: RaceOdds;
  // picks are numberFire
  isNumberFire: boolean;
}

const DerbyPick = ({
  runnerChance = "Favorite",
  runnerId = 12,
  runnerName = "1",
  winAmount = 100,
  raceTypeCode = RaceTypeCodeEnum.THOROUGHBRED,
  qaLabel = "derby-pick",
  odds = { denominator: 1, numerator: 1 },
  isNumberFire = false
}: Props) => (
  <Container data-qa-label={qaLabel}>
    <LeftSide>
      <HighlightedTextWrapper
        chance={runnerChance.toLowerCase() as RunnerChance}
      >
        <DerbyChanceHighlighted data-qa-label={`${qaLabel}-chance`}>
          {runnerChance}
        </DerbyChanceHighlighted>
      </HighlightedTextWrapper>

      <RunnerNumberWrapper>
        <RunnerNumber
          runnerId={runnerId.toString()}
          raceTypeCode={raceTypeCode}
        />
      </RunnerNumberWrapper>

      <Text
        capitalize
        qaLabel={`${qaLabel}-runner-name`}
        color={buildColor("grey", "900")}
        fontSize={16}
        bold
      >
        {runnerName}
      </Text>
    </LeftSide>

    <TextDerbyPickOdds>
      {isNumberFire
        ? `$${Math.round(winAmount)}`
        : `${odds.numerator ?? 1}/${odds.denominator ?? 1}`}
    </TextDerbyPickOdds>
  </Container>
);

export default DerbyPick;
